export function Loader() {
  return (
    <div className="text-center">
      <div className="spinner-border sw-green" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
